export const COLLECT_USER_STATISTIC = process.env.REACT_APP_COLLECT_USER_STATISTIC;
const YANDEX_METRIC_ID_PROD = 33220413;
const YANDEX_METRIC_ID_DEV = 50931395;

export const YANDEX_METRIC_ID = COLLECT_USER_STATISTIC === 'prod'
  ? YANDEX_METRIC_ID_PROD
  : YANDEX_METRIC_ID_DEV

export const GA_TRACKING_ID = 'UA-59410402-2';


export const USE_GA = COLLECT_USER_STATISTIC === 'prod';
export const USE_YA = COLLECT_USER_STATISTIC === 'prod' || COLLECT_USER_STATISTIC === 'dev';
